module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"description":{"line1":"Your current plan only provides access to the","line2":"mobile app. If you\u0027re interested in using even more","line3":"features there\u0027s a plan for that, too."},"seePlans":"Explore all Keap plans","title":{"line1":"You\u0027re trying to access a web plan"}}}')
  delete Component.options._Ctor
}
